<script setup>
import HauptMenue from "../../components/HauptMenue.vue";
import FooterMenu from "../../components/FooterMenu.vue";
import DatenschutzHinweis from "../../components/DatenschutzHinweis.vue";
import DateInput from "../../components/DateInput.vue";
import ButtonSendDataSelfService from "../../components/ButtonSendDataSelfService.vue";
import ButtonBack from "../../components/ButtonBack.vue";
import { store } from "../../components/store.vue";
/** View-Komponente zum Erfassen eines Antrags auf Vorausberechung
 * @displayName Selfservice Antrag Vorausberechnung
 */
</script>
<script>
export default {
  name: "SelfServiceAntragVorausberechnung",

  components: {
    // myRouter: router,
    HauptMenue,
    FooterMenu,
    DatenschutzHinweis,
    ButtonSendDataSelfService,
    DateInput,
    ButtonBack,
    //VersorgungSelect
  },
  data() {
    return {
      store,
      meldung: "",
      renteBeginn1: "",
      renteBeginn2: "",
      renteBeginn3: "",
      ausscheidedatum: "",
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    window._paq.push(["setDocumentTitle", this.name]);
    window._paq.push(["trackPageView"]);
  },
  beforeCreate: function () {
    this.$servertalk.doLog("Create");
    this.$servertalk.doLog("#");
    if (typeof store.masterData.data.sService === "undefined") {
      store.masterData.data.sService = {};
    }
    if (typeof store.masterData.data.Entwuerfe === "undefined") {
      store.masterData.data.Entwuerfe = {};
    }
    if (
      typeof store.masterData.data.sService.Vorausberechnungen === "undefined"
    ) {
      store.masterData.data.sService.Vorausberechnungen = {};
    }
    if (
      typeof store.masterData.data.Entwuerfe.Vorausberechnung === "undefined"
    ) {
      store.masterData.data.Entwuerfe.Vorausberechnung = JSON.parse(
        '{"renteBeginn1":"","renteBeginn2":"","renteBeginn3":"","rentenart":"","ausscheidedatum":""}'
      );
      this.$servertalk.doLog("defined");
    }
  },
  methods: {
    sendDataFinished() {
      this.$servertalk.doLog("SendDummy");
      this.$servertalk.doLog(store.masterData.data.Entwuerfe);
    },
    getRenteBeginn1(d) {
      store.masterData.data.Entwuerfe.Vorausberechnung.renteBeginn1 = d;
    },
    getRenteBeginn2(d) {
      store.masterData.data.Entwuerfe.Vorausberechnung.renteBeginn2 = d;
    },
    getRenteBeginn3(d) {
      store.masterData.data.Entwuerfe.Vorausberechnung.renteBeginn3 = d;
    },
  },
};
</script>
<template>
  <div class="main-wrapper" :class="store.accessRestriction">
    <HauptMenue />
    <div>
      <div class="mt-36 md:mt-48 lg:mt-56 max-w-7xl mx-auto">
        <div class="max-w-5xl mx-auto mb-8 px-5 lg:px-0">
          <h1
            class="text-primary/75 font-bold text-xl sm:text-2xl md:text-3xl lg:text-4xl text-center mb-12 uppercase">
            Ich möchte einen Antrag auf Vorausberechnung stellen
          </h1>
          <div class="status-label mb-8">
            <span
              class="bearbeitung bg-yellow-500 text-tertiary inline-block py-1 px-2 text-sm uppercase mb-2">
              In Bearbeitung
            </span>
            <span class="infotext text-tertiary text-sm block">
              Dieses Dokument befindet sich in Bearbeitung, bitte bestätigen Sie
              Ihre Änderungen.
            </span>
          </div>
          <form>
            <label for="Versorgung" class="text-sm mb-2 block">Firma</label>
            <!--<VersorgungSelect
          name="Versorgung"

          /> -->
            <div class="grid xl:grid-cols-3 gap-5">
              <div>
                <label for="berRenteBeginn1" class="text-sm mb-2 block">
                  Gewünschter Rentenbeginn 1
                </label>
                <DateInput
                  name="renteBeginn1"
                  placeholder="gültiges Datum"
                  @date="getRenteBeginn1"
                  :default="renteBeginn" />
              </div>
              <div>
                <label for="berRenteBeginn2" class="text-sm mb-2 block">
                  Gewünschter Rentenbeginn 2
                </label>
                <DateInput
                  name="renteBeginn2"
                  placeholder="gültiges Datum"
                  @date="getRenteBeginn2"
                  :default="renteBeginn" />
              </div>
              <div>
                <label for="berRenteBeginn3" class="text-sm mb-2 block">
                  Gewünschter Rentenbeginn 3
                </label>
                <DateInput
                  name="renteBeginn3"
                  placeholder="gültiges Datum"
                  @date="getRenteBeginn3"
                  :default="renteBeginn" />
              </div>
            </div>

            <ButtonSendDataSelfService @finished="sendDataFinished" />
            <p>{{ meldung }}</p>
          </form>
          <ButtonBack />
        </div>
      </div>
    </div>

    <FooterMenu />
  </div>
</template>
